export default {
  LEFT_FACE: {
    id: 0,
    color: [110, 64, 170],
  },
  RIGHT_FACE: {
    id: 1,
    color: [143, 61, 178],
  },
  LEFT_UPPER_ARM_FRONT: {
    id: 2,
    color: [178, 60, 178],
  },
  LEFT_UPPER_ARM_BACK: {
    id: 3,
    color: [210, 62, 167],
  },
  RIGHT_UPPER_ARM_FRONT: {
    id: 4,
    color: [238, 67, 149],
  },
  RIGHT_UPPER_ARM_BACK: {
    id: 5,
    color: [255, 78, 125],
  },
  LEFT_LOWER_ARM_FRONT: {
    id: 6,
    color: [255, 94, 99],
  },
  LEFT_LOWER_ARM_BACK: {
    id: 7,
    color: [255, 115, 75],
  },
  RIGHT_LOWER_ARM_FRONT: {
    id: 8,
    color: [255, 140, 56],
  },
  RIGHT_LOWER_ARM_BACK: {
    id: 9,
    color: [239, 167, 47],
  },
  LEFT_HAND: {
    id: 10,
    color: [217, 194, 49],
  },
  RIGHT_HAND: {
    id: 11,
    color: [194, 219, 64],
  },
  TORSO_FRONT: {
    id: 12,
    color: [175, 240, 91],
  },
  TORSO_BACK: {
    id: 13,
    color: [135, 245, 87],
  },
  LEFT_UPPER_LEG_FRONT: {
    id: 14,
    color: [96, 247, 96],
  },
  LEFT_UPPER_LEG_BACK: {
    id: 15,
    color: [64, 243, 115],
  },
  RIGHT_UPPER_LEG_FRONT: {
    id: 16,
    color: [40, 234, 141],
  },
  RIGHT_UPPER_LEG_BACK: {
    id: 17,
    color: [28, 219, 169],
  },
  LEFT_LOWER_LEG_FRONT: {
    id: 18,
    color: [26, 199, 194],
  },
  LEFT_LOWER_LEG_BACK: {
    id: 19,
    color: [33, 176, 213],
  },
  RIGHT_LOWER_LEG_FRONT: {
    id: 20,
    color: [47, 150, 224],
  },
  RIGHT_LOWER_LEG_BACK: {
    id: 21,
    color: [65, 125, 224],
  },
  LEFT_FOOT: {
    id: 22,
    color: [84, 101, 214],
  },
  RIGHT_FOOT: {
    id: 23,
    color: [99, 81, 195],
  },
};
